<template>
  <v-text-field
    v-model.trim="moneyFormatted"
    :label="label"
    :class="clase"
    :error-messages="errormessages"
    :maxlength="maxlength"
    :disabled="disabled"
    :dense="dense"
    :clearable="clearable"
    prepend-inner-icon="mdi mdi-currency-usd"
    onkeypress="return /^[0-9]*$/.test(event.key);"
    @input="moneyFormatted = $event"
    @click:clear="clearMoney"
    @change="changeMoney" />
</template>
<script>
import { formatMoney, unformatMoney } from "@/helpers/money-methods";

export default {
  name: "MoneyField"
  , props: {
    name: {
      default: ""
      , type: String
    }
    , label: {
      default: ""
      , type: String
    }
    , value: {
      default: 0
      , type: Number
    }
    , disabled: {
      default: false
      , type: Boolean
    }
    , min: {
      default: 0
      , type: Number
    }
    , max: {
      default: null
      , type: Number
    }
    , errormessages: {
      default: ""
      , type: String
    }
    , clase: {
      default: ""
      , type: String
    }
    , dense: {
      default: false
      , type: Boolean
    }
    , maxlength: {
      default: ""
      , type: String
    }
    , clearable: {
      default: false
      , type: Boolean
    }
  }
  , data() {
    return {
      view: {
        elem: {
          menu: { date: false }
          , money: {
            value: this.value
            , disabled: false
          }
        }
      }
    };
  }
  , computed: {
    moneyFormatted: {
      get() {
        return formatMoney(this.view.elem.money.value);
      }
      , set(value) {
        this.view.elem.money.value = Number(unformatMoney(value, 2));
      }
    }
  }
  , methods: {
    changeMoney() {
      let val = this.view.elem.money.value;
      if (this.max && this.max != "" && val > this.max) {
        this.view.elem.money.value = this.max;
        val = this.max;
      }
      if (this.min && this.min != "" && val < this.min) {
        this.view.elem.money.value = this.min;
        val = this.min;
      }
      this.$emit("changeMoney", this.name, val);
    }
    , clearMoney() {
      this.view.elem.money.value = "";
      this.$emit("changeMoney", this.name, "");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/forms/MoneyField.vue